"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtractPosterRequest = void 0;
var extract_poster_specification_1 = require("../job/extract-poster-specification");
var source_1 = require("../job/source");
var ExtractPosterRequest = /** @class */ (function () {
    function ExtractPosterRequest(_a) {
        var _b = _a === void 0 ? {} : _a, sources = _b.sources, specifications = _b.specifications;
        this.sources = [];
        this.specifications = [];
        if (sources) {
            this.sources = sources.map(function (sourceData) { return new source_1.Source(sourceData); });
        }
        if (specifications) {
            this.specifications = specifications.map(function (specificationData) {
                return new extract_poster_specification_1.ExtractPosterSpecification(specificationData);
            });
        }
    }
    return ExtractPosterRequest;
}());
exports.ExtractPosterRequest = ExtractPosterRequest;
//# sourceMappingURL=extract-poster-request.js.map